import ImageCarouselViewer from "../../../../components/post/ImageCarouselViewer";
import type { useArticleData } from "../../hooks/useArticleData";

interface ArticleSectionFiguresProps {
  articleImages: ReturnType<typeof useArticleData>["articleImages"];
}

export function ArticleSectionFigures({
  articleImages,
}: ArticleSectionFiguresProps) {
  if (articleImages.length === 0) return null;
  const carouselImages = articleImages.map((image) => ({
    url: image.url,
    path: image.path,
    legend: image.legend ?? undefined,
    sizes: image.sizes,
  }));

  return (
    <section data-gtm-section="figures" data-gtm-order="6" className="pt-0!">
      <ImageCarouselViewer images={carouselImages} />
    </section>
  );
}
